import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-website-accessibility',
  templateUrl: './website-accessibility.component.html',
  styleUrls: ['./website-accessibility.component.scss']
})
export class WebsiteAccessibilityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
